import { useParentChildSharedState } from "./useSharedState";
import { ApiTabElementResponse, ApiProject } from "@incendium/api";
import { reportService } from "Apis";

export const useTabElements = (
  reportId: number,
  tabId: number,
  projectId?: number
) => {
  const fetchTabElements = async (project: ApiProject) => {
    const res = await reportService.reportServiceListElements({
      projectId: projectId || project.id as number,
      reportId: reportId as number,
      tabId: tabId as number,
    });
    return res.results || [];
  };

  const { childState, setChildState, refetch, loading, fetched } = useParentChildSharedState(
    "tabElements",
    [],
    [],
    tabId,
    fetchTabElements,
    fetchTabElements
  );

  return {
    tabElements: childState as ApiTabElementResponse[],
    setTabElements: setChildState,
    refetchTabElements: refetch,
    loading,
    fetched
  };
};
